import React from 'react';
import { Route } from '../../router/utils';
import Recurring from './Recurring';

export default ({ path }: any = {}) => {
    return <Route path={path} exact component={Recurring} />;
};
